import React from 'react'

const NewCopyIcon = () => {
  return (
    <div className="imageContainerBtn codeBlockButton">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ cursor: 'pointer' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 28V31C28 31.5523 27.5523 32 27 32L17 32C16.4477 32 16 31.5523 16 31V21C16 20.4477 16.4477 20 17 20L20 20L20 17C20 16.4477 20.4477 16 21 16H31C31.5523 16 32 16.4477 32 17L32 27C32 27.5523 31.5523 28 31 28H28ZM30.5 17.5L30.5 26.5H28L28 21C28 20.4477 27.5523 20 27 20L21.5 20L21.5 17.5L30.5 17.5Z"
          fill="#003087"
        />
      </svg>
    </div>
  )
}

export default NewCopyIcon
